exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".broker-card-content-top[data-v-4029fd9c], .broker-card-content-bottom[data-v-4029fd9c] {\n  transition: all 800ms;\n}\n\n", ""]);

// exports
